import React, { useEffect, useState } from 'react';
import { Box, styled } from '@mui/material';
import { StyledMediumTypography } from '../../theme/StyledElements';
import { SelectTimeComponent } from './SelectTimeComponent';
import { SelectTime } from '../../models/SelectTime';

const StyledDayTitle = styled(StyledMediumTypography)(() => ({
    textAlign: 'center',
    marginLeft: '-62px',
    marginBottom: '15px',
    marginTop: '24px'
}));

interface TimeCollectionDataProps {
    modify: boolean | undefined;
    title: string;
    timing: SelectTime[] | undefined;
    onDataChange: Function;
}

export function TimeCollectionData({
    modify,
    title,
    timing,
    onDataChange
}: TimeCollectionDataProps): React.ReactElement {
    const [time1, setTime1] = useState<SelectTime>({
        heureDeDebut: '07:30',
        heureDeFin: '07:30',
        disponible: false
    });
    const [time2, setTime2] = useState<SelectTime>({
        heureDeDebut: '07:30',
        heureDeFin: '07:30',
        disponible: false
    });
    const [time3, setTime3] = useState<SelectTime>({
        heureDeDebut: '07:30',
        heureDeFin: '07:30',
        disponible: false
    });

    useEffect(() => {
        if (timing) {
            setTime1(timing[0]);
            setTime2(timing[1]);
            setTime3(timing[2]);
        }
    }, [timing]);

    useEffect(() => {
        if (time1 || time2 || time3) {
            onDataChange([time1, time2, time3]);
        }
    }, [time1, time2, time3]);

    useEffect(() => {
        onDataChange([time1, time2, time3]);
    }, []);

    const onLundi1FieldChange = (state: string, value: string | boolean): void => {
        setTime1({ ...time1, [state]: value });
    };
    const onLundi2FieldChange = (state: string, value: string | boolean): void => {
        setTime2({ ...time2, [state]: value });
    };
    const onLundi3FieldChange = (state: string, value: string | boolean): void => {
        setTime3({ ...time3, [state]: value });
    };

    return (
        <Box>
            <StyledDayTitle variant="body2">{title}</StyledDayTitle>
            <SelectTimeComponent
                modify={modify}
                checked={time1.disponible}
                startTime={time1.heureDeDebut}
                lastTime={time1.heureDeFin}
                onCheckedChange={(value: boolean): void => onLundi1FieldChange('disponible', value)}
                onStartTimeChange={(value: boolean): void =>
                    onLundi1FieldChange('heureDeDebut', value)
                }
                onLastTimeChange={(value: boolean): void =>
                    onLundi1FieldChange('heureDeFin', value)
                }
            />
            <SelectTimeComponent
                modify={modify}
                checked={time2.disponible}
                startTime={time2.heureDeDebut}
                lastTime={time2.heureDeFin}
                onCheckedChange={(value: boolean): void => onLundi2FieldChange('disponible', value)}
                onStartTimeChange={(value: boolean): void =>
                    onLundi2FieldChange('heureDeDebut', value)
                }
                onLastTimeChange={(value: boolean): void =>
                    onLundi2FieldChange('heureDeFin', value)
                }
            />
            <SelectTimeComponent
                modify={modify}
                checked={time3.disponible}
                startTime={time3.heureDeDebut}
                lastTime={time3.heureDeFin}
                onCheckedChange={(value: boolean): void => onLundi3FieldChange('disponible', value)}
                onStartTimeChange={(value: boolean): void =>
                    onLundi3FieldChange('heureDeDebut', value)
                }
                onLastTimeChange={(value: boolean): void =>
                    onLundi3FieldChange('heureDeFin', value)
                }
            />
        </Box>
    );
}
